<template>
  <transition :name="transitionName">
    <div v-show="visible" :style="customStyle" class="back-to-ceiling">
      <div class="mobile">
        <download-tooltip position="right" class="dt" />
      </div>
      <div class="top" @click="backToTop"></div>
    </div>
  </transition>
</template>

<script>
import DownloadTooltip from '../DownloadTooltip'
export default {
  components: { DownloadTooltip },
  name: 'BackToTop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    backPosition: {
      type: Number,
      default: 0
    },
    customStyle: {
      type: Object,
      default: function() {
        return {
          right: '10px',
          bottom: '60px',
          width: '40px',
          'border-radius': '4px'
        }
      }
    },
    transitionName: {
      type: String,
      default: 'fade'
    }
  },
  data() {
    return {
      visible: false,
      interval: null,
      isMoving: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
    },
    backToTop() {
      if (this.isMoving) return
      const start = window.pageYOffset
      let i = 0
      this.isMoving = true
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
          this.isMoving = false
        } else {
          window.scrollTo(0, next)
        }
        i++
      }, 16.7)
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b
      return -c / 2 * (--t * (t - 2) - 1) + b
    }
  }
}
</script>
<style lang="less" scoped>
.back-to-ceiling {
  position: fixed;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}

/*
.back-to-ceiling:hover {
  background: #d5dbe7;
}
*/

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
.mobile, .top {
  width: 40px;
  height: 40px;
}
.mobile {
  position: relative;
  margin-bottom: 30px;
  background: url("~@public/assets/web/btn_phone_download_n@2x.png") no-repeat center;
  background-size: contain;

  .dt {
    display: none;
    top: auto;
    left: -240px;
    bottom: -120px;
  }

  &:hover {
    background: url("~@public/assets/web/btn_phone_download_s@2x.png") no-repeat center;
    background-size: contain;

    .dt {
      display: block;
    }
  }
}
.top {
  background: url("~@public/assets/web/btn_top_n@2x.png") no-repeat center;
  background-size: contain;

  &:hover {
    background: url("~@public/assets/web/btn_top_s@2x.png") no-repeat center;
    background-size: contain;
  }
}
@media all and(max-width: 768px) {
  .mobile {
    display: none;
  }
}
</style>
